export function processError (data) {

    if(data){
     return JSON.stringify(data).replace(/[&\/\\#,[\]+()$~%.'"*?<>{}]/g, ' ') ;
    }else {
        return "Bad Request";
    }
}